import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "../data/content";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine, MaskedLineInView } from "../components/MaskedLine";

const TINTS = ["ground-lab", "ground-highlighter", "ground-margin"];

export default function InsightsIndexPage() {
  return (
    <main data-testid="page-insights">
      <section className="ground-paper pt-[104px] pb-14 md:pt-[132px] md:pb-20">
        <div className="wrap">
          <div className="flex items-center gap-4 mb-10">
            <span className="series-stamp"><span>Field Notes</span></span>
            <span className="stamp-dim">Compiled by Jasmeen Kaur</span>
          </div>
          <h1 className="h-hero max-w-[1200px]" style={{ fontSize: "clamp(56px, 9vw, 156px)" }}>
            <MaskedLine>On human capability</MaskedLine>
            <MaskedLine delay={0.1}><span className="claim">in the age of AI.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[720px]">
            Field notes from inside enterprise training rooms. What we&rsquo;re seeing in L&amp;D, where AI is reshaping the value of human work, and what the data is starting to show.
          </p>
        </div>
      </section>

      <section className="ground-paper sec-pad">
        <div className="wrap border-t-[1.5px] border-[color:var(--ink)] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {INSIGHTS.map((a, i) => (
            <Link
              key={a.slug}
              to={`/insights/${a.slug}`}
              data-testid={`insights-page-card-${a.slug}`}
              className={`${TINTS[i % TINTS.length]} group p-8 md:p-10 border-b-[1.5px] border-[color:var(--ink)] ${i > 0 ? "md:border-l-[1.5px]" : ""}`}
            >
              <div className="flex items-start justify-between">
                <span className="stamp">{a.category}</span>
                <ArrowUpRight size={22} className="text-[#0E1330] transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <h2 className="h-tile mt-10">
                <MaskedLineInView>{a.title}</MaskedLineInView>
              </h2>
              <p className="font-aside mt-6 text-[17px]" style={{ lineHeight: 1.55 }}>{a.excerpt}</p>
              <div className="mt-12 pt-4 border-t border-[color:var(--line-soft)]">
                <p className="receipt"><span>{a.readTime}</span><span>1 idea</span></p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <ContactSplit />
    </main>
  );
}
